
//alpham endpoints
const base_url = process.env.REACT_APP_API_BASE_URL;
const auth_url = process.env.REACT_APP_API_BASE_URL;
const users_url = process.env.REACT_APP_API_BASE_URL;
const files_url = process.env.REACT_APP_API_BASE_URL;

//local api
// const base_url = 'http://127.0.0.1:8000/api';
// const auth_url = 'http://127.0.0.1:8000/api';
// const users_url = 'http://127.0.0.1:8000/api';
// const files_url = 'http://127.0.0.1:8000/api';


const endpointNames = {

    'base': base_url,
    'agent': base_url + '/agent',
    'policyHolder': base_url + '/policy-holder',
    'manager': base_url + '/manager',
    'position': base_url + '/position',
    'team': base_url + '/team',
    'beneficiaries': base_url + '/beneficiaries/',
    "beneficiary": base_url + '/beneficiary',
    'dependents': base_url + '/dependents/',
    "dependent": base_url + '/dependent',
    'comprehensive_funeral': base_url + '/product/',
    'saving': base_url + '/product/',
    'funeral': base_url + '/product/',
    'accident': base_url + '/product/accident/',
    'employer': base_url + '/aggregator',
    'employers': base_url + '/aggregators',
    'operation': base_url + '/policyholder/operation/',
    'product': base_url + '/product',
    'package': base_url + '/',
    'products': {
        'savings': base_url + '/product/savings/',
        'funeral': base_url + '/products',
        'comprehensive': base_url + '/products'
    },
    'policy': base_url + '/policy/',
    'allocate': {
        'accident': base_url + '/policy/',
        'savings': base_url + '/policy/',
        'funeral': base_url + '/policy/',
        'comprehensive': base_url + '/policy/',
        'nhaka_yangu': base_url + '/policy/'
    },
    'invoicing': base_url + '/download/invoice/',
    'payments': {
        "cash": base_url + '/payment/cash/',
        "debitOrder": base_url + "/payment/debitOrder/",
        "getAll": base_url + '/payments'
    },
    "currencies": base_url + '/currencies',
    'payment': base_url + '/payment/',
    'claims': {
        'update_claim': base_url + '/update-claim/',
        'update_claim_file': base_url + '/update-claim/',
        'accident_death_claim': base_url + '/accident-death-claim/',
        'accident_injury_claim': base_url + '/accident-injury-claim/',
        'accident_death_claims': base_url + '/accident-death-claims',
        'accident_injury_claims': base_url + '/accident-injury-claims',
        'comprehensive': {
            "get": base_url + '/comprehensive-claims',
            "post": base_url + '/comprehensive-claim/'
        },
        'funeral': {
            "get": base_url + '/funeral-claims',
            "post": base_url + '/funeral-claim/'
        },
        'savings': {
            "get_death_claims": base_url + '/savings-death-claims',
            "get_surrenders": base_url + '/savings-surrender-claims',
            "get_refund_claims": base_url + '/savings-refund-claims',
            "get_withdrawals": base_url + '/savings-partial-withdrawal-claims',
            'get_maturity': base_url + '/savings-maturity-claims',
            //    post
            "post_death_claim": base_url + '/savings-death-claim/save-claim',
            "post_surrender": base_url + '/savings-surrender-claim/save-claim',
            "post_refund_claim": base_url + '/savings-refund-claim/save-claim',
            "post_withdrawal": base_url + '/savings-partial-withdrawal-claim/save-claim',
            "post_maturity": base_url + '/store-savings-maturity'
        },
        'inotho': {
            "get_death_claims": base_url + '/inotho-death-claims',
            "get_surrenders": base_url + '/inotho-surrender-claims',
            "get_refund_claims": base_url + '/inotho-refund-claims',
            "get_withdrawals": base_url + '/inotho-partial-withdrawal-claims',
            "get_hospital_cash": base_url + '/inotho-hospital-claims',
            "get_personal_accident": base_url + '/inotho-accident-claims',
            "get_funeral_cash": base_url + '/inotho-funeral-claims',
            'get_maturity': base_url + '/inotho-maturity-claims',
            //    post
            "post_death_claim": base_url + '/store-inotho-death',
            "post_surrender": base_url + '/store-inotho-surrender',
            "post_refund_claim": base_url + '/store-inotho-refund',
            "post_withdrawal": base_url + '/store-inotho-partial-withdrawal',
            "post_hospital_cash": base_url + '/store-inotho-hospital',
            "post_personal_accident": base_url + '/store-inotho-accident',
            "post_funeral_cash": base_url + '/store-inotho-funeral',
            'post_maturity': base_url + '/store-inotho-maturity'
        },
        'update': {
            'validate': base_url + '/validate-claim/',
            'authorise': base_url + '/authorise-claim/',
            'reject': base_url + '/reject-claim/',
            'pay': base_url + '/pay-claim/',
            'initiate': base_url + '/initiate-payment-claim/',
            'suspend': base_url + '/suspend-claim/'
        },
    },
    'policies': {
        "getAll": base_url + '/policies',
        "search": base_url + '/policy/search/',
        'accident': base_url + '/policies/accident',
        'comprehensive': base_url + '/policies/comprehensive',
        'funeral': base_url + '/policies/funeral',
        'savings': base_url + '/policies/savings',
        "update": base_url + '/policy/update/',
        "delete": base_url + '/policy/',
        "alterations": base_url + '/alterations',
        "investment_accounts": base_url + '/investment-accounts',
        "investment_account": base_url + '/investment-account/',
        "insurance_accounts": base_url + '/insurance-accounts',
        "insurance_account": base_url + '/insurance-account/',
        'get_policy': base_url + '/policy/'
    },
    'representatives': base_url + '/representative',
    'representative': base_url + '/representative',
    'representativeCategories': base_url + '/representative-categories',
    'commissions': {
        "get": base_url + '/commissions',
        "update": base_url + '/',
        'funeral': base_url + '/commissions/funeral',
        'comprehensive': base_url + '/commissions/comprehensive',
        'savings': base_url + '/commissions/savings',
        'accident': base_url + '/commissions/accident',
        'pfuma': base_url + '/commissions/inotho'
    },
    'files': {
        'accidentFileUpload': files_url + '/upload/accident/',
        'funeralFileUpload': files_url + '/upload/funeral/',
        'savingsFileUpload': files_url + '/upload/savings/',
        'comprehensiveFileUpload': files_url + '/upload/comprehensive/',
        'comprehensiveClaimUpload': files_url + '/upload/claim/comprehensive',
        'funeralClaimUpload': files_url + '/upload/claim/funeral',
        'savingWithdrawUpload': files_url + '/upload/claim/savings-partial-withdrawal',
        'savingDeathClaimUpload': files_url + '/upload/claim/savings-death',
        'savingSurrenderUpload': files_url + '/upload/claim/savings-surrender',
        'savingRefundUpload': files_url + '/upload/claim/savings-refund',
        'injuryClaimUpload': files_url + '/upload/claim/accident-injury',
        'deathClaimUpload': files_url + '/upload/claim/accident-death',
        //download endpoints
        'accidentFileDownload': files_url + '/download/accident/',
        'savingsFileDownload': files_url + '/download/savings/',
        'funeralFileDownload': files_url + '/download/funeral/',
        'comprehensiveFileDownload': files_url + '/download/comprehensive/',
        "bulkPayments": files_url + '/payment/stopOrder/',
        'downloadInvoice': files_url + '/download/invoice/',
        'comprehensiveClaimDownload': files_url + '/download/claim/comprehensive/',
        'funeralClaimDownload': files_url + '/download/claim/funeral/',
        'savingWithdrawDownload': files_url + '/download/claim/savings-partial-withdrawal/',
        'savingDeathClaimDownload': files_url + '/download/claim/savings-death/',
        'savingSurrenderDownload': files_url + '/download/claim/savings-surrender/',
        'savingRefundDownload': files_url + '/download/claim/savings-refund/',
        'injuryClaimDownload': files_url + '/download/claim/accident-injury/',
        'deathClaimDownload': files_url + '/download/claim/accident-death/',


    },
    'login': auth_url + '/login',
    'users': {
        "get": users_url,
        "assign": users_url + "/users/assign-role",
        "updateRole": users_url + "/users/update-role",
        'unAssign': users_url + '/users/un-assign-role',
        'assignDirect': users_url + '/users/assign-direct-permission',
        'unAssignDirect': users_url + '/users/un-assign-direct-permission',
        "update": users_url + '/users/update/',
        "delete": users_url + '/users/delete/'
    },
    'edit-user': users_url + '/users/',
    'permissions': {
        'get': users_url + '/permissions',
        'create': users_url + '/permissions/create'

    },
    'roles': {
        'getAll': users_url + '/roles',
        'getRole': users_url + '/roles/',
        'assign': users_url + '/roles/assign-permission',
        'unAssign': users_url + '/roles/un-assign-permission',
        'delete': users_url + '/roles/delete/',
        'create': users_url + '/roles/create',

    },
    "settings": {
        // teams
        "getTeams" : base_url + '/teams',
        "addTeam": base_url + '/team',
        "updateTeam": base_url + '/team',
        // positions
        "getPositions": base_url + '/positions',
        "addPosition": base_url + '/position',
        "updatePosition": base_url + '/position',
        // channels
        "getChannels": base_url + '/channels',
        "addChannel": base_url + '/channel',
        "updateChannel": base_url + '/channel',
        // paymentMethods
        "getPaymentMethods": base_url + '/payment_methods',
        "addPaymentMethod": base_url + '/payment_method',
        "updatePaymentMethod": base_url + '/payment_method',
        //     settings
        'settings': base_url + '/settings',
        //     industries
        "industries": base_url + '/industry',
        "getReasons": base_url + '/reasons',
        "addReason": base_url + '/reason',
        "deleteReason": base_url + '/reason/'
    },
    "report": {
        "accidentClaims": base_url + '/accident_claims',
        "funeralClaims": base_url + '/standard_funeral_claims',
        "comprehensiveClaims": base_url + '/comprehensive_claims_data',
        "investmentClaims": base_url + '/investment_claims',
        "inothoClaims": base_url + '/inotho_claims',
        "deathClaims": base_url + '/death_claims',
        "deathClaimsByProduct": base_url + '/death_claims_per_product',
        "paByAggregator": base_url + '/pa_by_aggregator',
        "paByIndustry": base_url + '/pa_by_industry',
        "paByPolicyType": base_url + '/pa_by_policy_type',
        "paidClaims": base_url + '/claims_paid_analysis',
        "paymentHistory": base_url + '/payment_history',
        "commissionsData": base_url + '/commissions_data',
        "revenueData": base_url + '/revenue',
        "savingsDueToMature": base_url + '/savings_due_to_mature',
        "inothoDueToMature": base_url + '/inotho_due_to_mature',
        "leads": base_url + '/leads',
        "dashboard": base_url + '/dashboard',
        "listOfAccounts": base_url + '/list_of_accounts',
        "riskProfiles": base_url + '/risk_profiles',
        "deleted": base_url + '/deleted_policies',
        "claimsTurnAround": base_url + '/claims_turn_around_time'
    },
    "audit": {
        "getAll": base_url + '/audits'
    }

};


export default endpointNames;
